import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
export const tableOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: false,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    labelPosition: 'right',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: '450px',
    emptyText: '暂无数据',
    menu: false,
    column: [
      {
        label: '人员姓名',
        prop: 'name',
        search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
        span: 24,
      },
      {
        label: '人员工号',
        prop: 'jobNo',
        search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
        span: 24,
      },
      {
        label: '验证方式',
        prop: 'verifyModeName',
        search: true,
        type: 'input',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
        span: 24,
        // dicData: [{
        //     label: '仅卡',
        //     value: '仅卡'
        //   },
        //   {
        //     label: '人脸',
        //     value: '人脸'
        //   },
        //   {
        //     label: '其他',
        //     value: '其他'
        //   },
        // ]
      },
      {
        label: '门禁区域名称',
        prop: 'areaDevGroupName',
        search: false,
        hide: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        span: 24,
        align: 'center'
      },

      {
        label: '设备名称',
        prop: 'deviceName',
        search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
        span: 24,
      },
      {
        label: '读头名称',
        prop: 'readerName',
        // search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
        span: 24,
      },

      {
        label: '通行时间',
        prop: 'trafficTime',
        // search: true,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        // searchSlot: true,
        viewDisplay: true,
        align: 'right',
        type: 'datetime',
        span: 24,
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
      {
        label: '通行时间',
        prop: 'passageTime',
        search: true,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        // searchSlot: true,
        type: 'datetimerange',
        viewDisplay: false,
        align: 'right',
        hide: true,
        span: 24,
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },





      {
        label: '图片',
        prop: 'trafficFileCode',
        hide: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        formslot: true,
        viewslot: true,
        span: 24,
        align: 'center',
      },

    ]
  }
}